/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useEffect, useState } from 'react'
import { useWatch, useFormContext } from 'react-hook-form'
import {
  useTranslate,
  useLocaleState,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  required,
} from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { BranchMultiSelectInputProps } from './type'

export const BranchAutocompleteArrayInput: React.FC<BranchMultiSelectInputProps> = ({
  source = 'access_branches',
  depField = 'publish_condition',
  expectedValue = 's',
  disabled,
  label = '',
  ...props
}) => {
  const translate = useTranslate()
  const [locale] = useLocaleState()
  const [filters, setFilters] = useState({ name: '' })
  const optionRenderer = useCallback(
    (choice): string =>
      `${choice['branch_code']} ${choice[`branch_name_${locale}`] || choice['branch_name_th']}`,
    [locale],
  )

  const fieldCond = useWatch({ name: depField })
  const { unregister } = useFormContext()
  const validator = {
    validate: [required()],
  }

  useEffect(() => {
    if (fieldCond !== expectedValue) {
      unregister(source)
    }
  }, [expectedValue, fieldCond, source, unregister])

  if (!depField) return null

  return fieldCond === expectedValue ? (
    <ReferenceArrayInput
      source={source}
      reference='branches'
      sort={{ field: 'branch_code', order: 'ASC' }}
      filter={filters}
    >
      <AutocompleteArrayInput
        optionText={optionRenderer}
        fullWidth
        label={translate(`${COMMON_FIELDS}.specific_branches.label`) || label}
        setFilter={(searchText: string): void => setFilters({ name: searchText })}
        {...(fieldCond === expectedValue ? validator : '')}
        disabled={disabled}
        {...props}
      />
    </ReferenceArrayInput>
  ) : null
}
